import React from 'react';

export function Switch({ checked = false, onChange, label, disabled = false, style = {} }) {
  const toggle = () => { if (!disabled && onChange) onChange(!checked); };
  return (
    <span onClick={toggle} role="switch" aria-checked={checked}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6em', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)', userSelect: 'none', ...style }}>
      <span style={{ position: 'relative', width: 46, height: 26, flexShrink: 0, borderRadius: 'var(--radius-pill)', background: checked ? 'var(--energy)' : 'var(--neutral-300)', boxShadow: checked ? 'var(--glow-soft-green)' : 'inset 0 1px 2px rgba(0,0,0,0.12)', transition: 'background var(--dur-fast) var(--ease-out)' }}>
        <span style={{ position: 'absolute', top: 3, left: checked ? 23 : 3, width: 20, height: 20, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(8,27,51,0.3)', transition: 'left var(--dur-fast) var(--ease-spring)' }} />
      </span>
      {label && <span>{label}</span>}
    </span>
  );
}
